export default "__VITE_ASSET__ac87096f__"